import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from '@boma/ui';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { IndexComponent } from './containers/users/index/index.component';
import * as fromUsers from './+state/users/users.reducer';
import { UsersEffects } from './+state/users/users.effects';
import { UsersFacade } from './+state/users/users.facade';
import { DetailsComponent } from './containers/users/details/details.component';
import { RolesFacade } from './+state/roles/roles.facade';
import {
  LocationsEffects,
  LocationsFacade,
  VehiclesEffects,
  VehiclesFacade,
} from '@boma/supplier-portal/shared/state';
import * as fromVehicles from '@boma/supplier-portal/shared/state';
import * as fromLocations from '@boma/supplier-portal/shared/state';
import { SupplierPortalRolesModule } from './supplier-portal-roles.module';
import { EntityResolver } from '@boma/supplier-portal/shared/services';
import { ArchivedUsersComponent } from './containers/users/archived-users/archived-users.component';

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    FormsModule,
    ReactiveFormsModule,
    SupplierPortalRolesModule,
    RouterModule.forChild([
      { path: '', pathMatch: 'full', component: IndexComponent },
      {
        path: 'details/:entityId/:userId',
        component: DetailsComponent,
        resolve: {
          entityData: EntityResolver,
        },
      },
    ]),
    StoreModule.forFeature(fromUsers.USERS_FEATURE_KEY, fromUsers.userReducer),
    EffectsModule.forFeature([UsersEffects]),
    StoreModule.forFeature(
      fromVehicles.VEHICLES_FEATURE_KEY,
      fromVehicles.vehicleReducer
    ),
    EffectsModule.forFeature([VehiclesEffects]),
    StoreModule.forFeature(
      fromLocations.LOCATIONS_FEATURE_KEY,
      fromLocations.locationReducer
    ),
    EffectsModule.forFeature([LocationsEffects]),
  ],
  declarations: [IndexComponent, DetailsComponent, ArchivedUsersComponent],
  providers: [UsersFacade, RolesFacade, VehiclesFacade, LocationsFacade],
})
export class SupplierPortalUsersModule {}
